import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const dateSelectorContainerStateBase = css`
  border: 1px solid ${theme.colors.neutral20};
  outline: none;
  &:hover {
    border-color: ${theme.colors.neutral30};
  }
`;

const dateSelectorContainerStateError = css`
  border: 1px solid ${theme.colors.critical30};
  &:hover {
    border-color: ${theme.colors.critical30};
  }
`;

export const styles = {
  navigatorContainer: css`
    display: flex;
    align-items: center;
  `,
  navigationButton: css`
    padding: ${theme.spacing(0.5)};
    width: 24px;
    height: 24px;
    z-index: ${theme.zIndex.low};
    &:focus-visible {
      box-shadow: 0 0 0 0 ${theme.colors.white}, 0 0 0 2px ${theme.colors.neutral50};
    }
  `,
  active: css`
    border-color: ${theme.colors.primary50};
    &:hover {
      border-color: ${theme.colors.primary50};
    }
  `,
  dateSelectorContainer: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing(0.5, 1, 0.5, 0.5)};
    background-color: ${theme.colors.neutral5};
    border-radius: ${theme.borderRadius.medium};
    white-space: nowrap;
    height: 32px;

    .datepicker-input-field {
      height: auto;
      padding: 0;
      border: none;
      box-shadow: none !important;
    }
  `,
  dateSelectorContainerState: (isActive: boolean, hasError?: boolean) =>
    cx(dateSelectorContainerStateBase, isActive && styles.active, hasError && dateSelectorContainerStateError),
  calendarIconWithInput: css`
    padding: ${theme.spacing(0.5)};
    width: 24px;
    height: 24px;
    &:hover {
      background-color: ${theme.colors.neutral20};
    }
  `,
  calendarIcon: css`
    padding: ${theme.spacing(0.5)};
    width: 100%;
    &:hover {
      background-color: ${theme.colors.neutral20};
    }
  `,
  dateLabel: css`
    flex: 1;
    padding: ${theme.spacing(0, 0.25)};
    border-radius: ${theme.borderRadius.small};
    overflow: hidden;
    &:hover {
      background-color: ${theme.colors.neutral20};
    }
  `,
  dateText: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing(0.5)};
  `,
};
